module.exports = __webpack_public_path__ + "images/category_lp/brand/new/store_images/1_1022d046e3f2a74cdcf2bc99c4078fea.png";